// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"caret-down-small","fill":"currentColor","d":"M12.0001 15L17.5 9.5H6.5L12.0001 15Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-caret-down-small')
export default class CaretDownSmallIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'caret-down-small',
    }
  }
}
